<section class="tinea-table"
  [ngClass]="tableConfiguration.cssClass">
  <!-- Header row -->
  <div class="table__header-row row">
    @if (tableConfiguration.withSelect) {
      <div class="row-select">Select</div>
    }
    @for (column of tableColumns; track column) {
      @if (column.displayed) {
        <div  [ngClass]="column.cssClass" [id]="column.propertyName">
          <span>{{column.name}}</span>
        </div>
      }
    }

    @if (tableConfiguration.withMore) {
      <div class="more">More</div>
    }
  </div>
  @if (tableData && tableData.list.length > 0 && !loadingItems) {
    <ul class="table__data">
      <!-- Content rows -->
      @for (dataItem of tableData.list; track dataItem; let i = $index) {
        <li class="table__data-row" [ngClass]="(tableConfiguration.detailComponent) ? tableConfiguration.detailComponent : ''">
          @if (!tableConfiguration.withIntegratedComponent) {
            <div class="data__main-row row">
              <!-- Columns -->
              <!-- Column with selection checkboxes -->
              @if (tableConfiguration.withSelect) {
                <div class="row-select" >
                  @if (isSelected(dataItem.uid)) {
                    <label class="label-state done" title="Selected" (click)="pushToSelected(dataItem.uid, false)" role="button" aria-label="Selected"></label>
                  } @else {
                    <label class="label-state" title="Not selected" (click)="pushToSelected(dataItem.uid, true)" role="button" aria-label="Not selected"></label>
                  }
                </div>
              }
              <!-- Custom columns depending on object type -->
              @for (column of tableColumns; track column) {
                @switch (column.type) {
                  @case (columnTypes.MAIL) {
                    <div [ngClass]="column.cssClass">
                      <a href="mailto:{{dataItem[column.propertyName]}}">{{dataItem[column.propertyName]}}</a>
                    </div>
                  }
                  @case (columnTypes.DATE) {
                    @if (column.nestedProperty) {
                      <div [ngClass]="column.cssClass">
                        {{ dataItem[column.propertyName][column.nestedProperty] | date: dateFormat:undefined:language }}
                      </div>
                    } @else {
                      <div [ngClass]="column.cssClass">{{ dataItem[column.propertyName] | date: dateFormat:undefined:language }} </div>
                    }
                  }
                  @case (columnTypes.LINK) {
                    <div [ngClass]="column.cssClass">
                      <a [href]="dataItem[column.propertyName]">{{dataItem[column.propertyName]}}</a>
                    </div>
                  }
                  @default {
                    @if (column.nestedProperty) {
                      <div [ngClass]="column.cssClass">
                        {{ dataItem[column.propertyName][column.nestedProperty] }}
                      </div>
                    } @else {
                      <div [ngClass]="column.cssClass">{{ dataItem[column.propertyName] }}</div>
                    }
                  }
                }
              }
              <!-- More details column -->
              @if (tableConfiguration.withDetail === true) {
                <div class="data__more" role="button" aria-label="Details" (click)="showMoreOrLess(dataItem.uid)" data-toggle="collapse" [attr.data-target]="'#collapse' + i" aria-expanded="false"
                  [attr.aria-controls]="'#collapse' + i">
                  <div><i class="fas fa-angle-{{expandedItems[dataItem.uid] ? 'up' : 'down'}}" title="Toggle panel"></i></div>
                  @if (tableConfiguration.detailComponent === 'apis' || tableConfiguration.detailComponent === 'fsa') {
                    <div>
                      <a [routerLink]="['/admin/apis/api-detail/' + dataItem.name + '/' + dataItem.uid]" routerLinkActive="router-link-active" >
                        <!-- <fa-icon icon="angle-double-right" title="Go to details"></fa-icon> --> Go to details
                      </a>
                    </div>
                  }
                </div>
              } @else {
                @switch (tableConfiguration.detailComponent) {
                  @case ('API managers') {
                    <div class="data__more">
                      <a [routerLink]="['/admin/api-managers/api-manager-detail/' + dataItem.uid]" routerLinkActive="router-link-active" >
                        <!-- <fa-icon icon="angle-double-right"></fa-icon> --> data__more
                      </a>
                    </div>
                  }
                }
              }
            </div>
          } @else {
            @switch (tableConfiguration.detailComponent) {
              @case ('event') {
                <app-event [event]=dataItem [tableColumns]="tableColumns"></app-event>
              }
              @case ('event-group') {
                <app-event-group [group]=dataItem [tableColumns]="tableColumns" [data]="data"></app-event-group>
              }
              @case ('tag-group') {
                <app-tag-group [selectedTagsByDefault]="selectedTagsByDefault" [group]=dataItem [tableColumns]="tableColumns" [columnsToNotDisplay]="columnsToNotDisplay" [data]="data" (eventOnClick)="onEventOnClick($event)"></app-tag-group>
              }
              @case ('alarm') {
                <app-alarm [alarm]=dataItem></app-alarm>
              }
            }
          }
          <!-- Details panel -->
          @if (tableConfiguration.withDetail && expandedItems[dataItem.uid]) {
            <section class="collapse data__collapsed-row" id="collapse{{i}}">
              @switch (tableConfiguration.detailComponent) {
                @case ('event') {
                  <app-event [event]=dataItem></app-event>
                }
              }
            </section>
          }
        </li>
      }
    </ul>
  } @else {
    <div id="no-data-found">
      @if (noDataFound && !!tableConfiguration.detailComponent && !loadingItems) {
        <p>
          @switch (tableConfiguration.detailComponent) {
            @case ('alarm') {
              <span>Aucune alarme</span>
            }
            @default {
              <span>Aucun événement</span>
            }
          }
        </p>
      }
    </div>
  }
  <!-- <div class="data__delete" *ngIf="tableConfiguration.withSelect">
  <button class="bttn delete" (click)="openDeleteDialog()"
  [disabled]="selectedItems.length === 0" [ngClass]="{'btn-disabled': selectedItems.length === 0}"> Delete selected</button>
</div> -->

@if ((tableData && tableData.list.length > 0 && tableConfiguration.withPagination) && !loadingItems) {
  <div class="wrap-pagination">
    <div class="pagination">
      <i class="icon-arrow-left-circle"
        (click)="goToPrevPagination($event.target)"
      [class.disabled-img]="!paging?.previousItemsLink" role="button" aria-label="Previous page" title="Page précédente"></i>
      <span class="text">
        {{ paging.offset + 1 }} - {{ currentTotal }}
        <!-- Other paging variant:
        {{page}} <span class="little-text">de</span> {{total}} <span class="little-text">pages </span> -->
      </span>
      <i class="icon-arrow-right-circle"
        (click)="goToNextPagination($event.target)"
      [class.disabled-img]="!paging?.nextItemsLink" role="button" aria-label="Next page" title="Page suivante"></i>
    </div>
  </div>
}
</section>

<ng-template #deleteAlert let-data>
  <div class="delete-dialog">
    <div mat-dialog-content class="d-flex delete__content">
      <p>Delete {{tableConfiguration.detailComponent}}: {{data.names}}?</p>
    </div>
    <div mat-dialog-actions class="d-flex delete__actions">
      <button cdkFocusInitial (click)="onNoClick()" class="bttn color-1">No</button>
      <button (click)="deleteItems(data.uids)" class="bttn delete">Yes</button>
    </div>
  </div>
</ng-template>

<!-- <app-loading [isLoadingHidden]=!loadingItems class="loading"></app-loading> -->
